<div class="d-flex flex-column gap-3">
	<h4 class="fw-bold">{{ 'Messages' | translate }}</h4>
	@if (!isLoading) {
	<div class="card elevated border-0">
		<div class="d-flex flex-column gap-3 align-items-center">
			<span class="circle bg-base-1">
				<img
					src="../assets/images/nordea/icons/svg/mail_unread.svg"
					height="80"
					width="80"
					class="filter-white"
				>
			</span>
			<div class="message-section">
				<p class="title text-base-1 mb-2">{{ 'Messages_From' | translate }}</p>
				<p class="font-smaller mb-0">
					{{ message.Sender.Name }} {{ message.Sender.Lastname }}
				</p>
			</div>
			<div class="message-section">
				<p class="title text-base-1 mb-2">
					{{ 'Messages_Subject' | translate }}
				</p>
				<p class="font-smaller mb-0">{{ message.Subject }}</p>
			</div>
			<div class="message-section">
				<p class="title text-base-1 mb-2">
					{{ 'Messages_Message' | translate }}
				</p>
				<p class="font-smaller mb-0">{{ message.Body }}</p>
			</div>
			@if (message.File != null) {
			<div
				class="d-flex flex-row align-items-center file-download"
				(click)="downloadFile(message.File)"
			>
				<div class="file-name bg-base-1 text-white">
					{{ message.File.Filename }}
				</div>
				<div class="circle-container">
					<div class="circle bg-base-1">
						<img
							src="../assets/images/nordea/icons/svg/paper_clip.svg"
							height="35"
							width="35"
							class="filter-white"
						>
					</div>
				</div>
			</div>
			}
		</div>
	</div>
	@if (isReplyMessage) {
	<div class="card elevated border-0">
		<form
			[formGroup]="messageForm"
			(ngSubmit)="replyMessage()"
			class="d-flex flex-column gap-3"
		>
			<div class="d-flex flex-column gap-2">
				<label for="Subject">
					{{ 'Messages_Subject' | translate }}
					<span class="text-danger">*</span>
				</label>
				<input
					class="form-control"
					type="text"
					id="Subject"
					formControlName="Subject"
				>
				@if (messageForm.get('Subject')?.hasError('required') &&
				messageFormSubmitted) {
				<small class="text-danger">{{ 'field_required' | translate }}</small>}
			</div>
			<div class="d-flex flex-column gap-2">
				<label for="MessageBody">
					{{ 'Messages_Message' | translate }}
					<span class="text-danger">*</span>
				</label>
				<textarea
					class="form-control"
					id="MessageBody"
					formControlName="MessageBody"
					rows="5"
				></textarea>
				@if (messageForm.get('MessageBody')?.hasError('required') &&
				messageFormSubmitted) {
				<small class="text-danger">{{ 'field_required' | translate }}</small>}
			</div>
			<div class="d-flex flex-column gap-2">
				<label for="IncidentFile">
					{{ 'messages_file_attachment' | translate }}
				</label>
				<div class="file-info">
					<p class="mb-1">
						<small>
							<strong>{{ 'accepted_file_types' | translate }}</strong>
							{{ 'accepted_file_types_text' | translate }}
						</small>
					</p>
					<p class="mb-0">
						<small>
							<strong>{{ 'accepted_file_size' | translate }}</strong>
							{{ 'accepted_file_size_text' | translate }}
						</small>
					</p>
				</div>
				<input
					hidden
					type="file"
					class="form-control-file"
					id="IncidentFile"
					multiple
					(change)="onImagePicked($event)"
					#fileInput
					accept=".pdf,.doc,.docx,.txt,.jpeg,.jpg,.png,.gif,.mp3,.wav,.aac,.mp4,.avi,.mov"
				>
				<button
					type="button"
					class="btn btn-sm btn-primary"
					(click)="fileInput.click()"
				>
					{{ 'upload_files' | translate }}
				</button>
				@if (selectedFiles?.length > 0) {
				<div class="file-list mt-2">
					<ul class="list-group list-group-flush">
						@for (file of selectedFiles; track file; let i = $index) {
						<li class="list-group-item">
							<div
								class="d-flex justify-content-between align-items-center gap-2"
							>
								<span class="file-name-text">{{ file.name }}</span>
								<button
									type="button"
									class="btn btn-delete text-danger"
									(click)="removeFile(i)"
									[attr.aria-label]="'remove_file' | translate"
								>
									&times;
								</button>
							</div>
						</li>
						}
					</ul>
				</div>
				}
			</div>
			<hr class="my-0">
			@if (isSendingMessage) {
			<div class="progress mt-2">
				<div
					class="progress-bar progress-bar-striped progress-bar-animated"
					role="progressbar"
					[attr.aria-valuenow]="progress"
					aria-valuemin="0"
					aria-valuemax="100"
					[ngStyle]="{ 'width' : progress.toString() + '%'}"
				></div>
			</div>
			}
			<div class="d-flex flex-column gap-2 message-feedback">
				@if (errorMessage) {
				<small class="text-danger">{{ errorMessage | translate }}</small>} @if
				(successMessage) {<small class="text-success"
					>{{ successMessage | translate }}</small
				>}
			</div>
			<div class="d-flex justify-content-between gap-2">
				@if (isWhistleblower()) {
				<button
					type="button"
					(click)="gotoIncidentDetail()"
					class="btn btn-primary"
				>
					{{ 'whistleblower_incident_report_detail' | translate }}
				</button>
				}
				<button
					[disabled]="isSendingMessage"
					class="btn btn-primary"
					type="submit"
				>
					{{ 'messages_send' | translate }}
				</button>
			</div>
		</form>
	</div>
	} @if (!isReplyMessage) {
	<div class="d-flex justify-content-between gap-2">
		@if (isWhistleblower()) {
		<button (click)="gotoIncidentDetail()" class="btn btn-primary">
			{{ 'whistleblower_incident_report_detail' | translate }}
		</button>
		} @if (isWhistleblower()) {
		<button (click)="initReplyMessage()" class="btn btn-primary">
			{{ 'message_reply' | translate }}
		</button>
		}
	</div>
	} }
</div>
